export default __webpack_public_path__ + "static/media/glass_c.3fe4e598.svg";